import { createReducer } from '@reduxjs/toolkit';
import { surveyAction } from './action';
import { SurveyState } from './model';

const initialState: SurveyState = {
  userListFilter: {
    regions: [],
    units: [],
    departments: [],
    divisions: [],
    levels: [],
    positions: [],
    restaurants: [],
    survey360Objects: [],
  },
  keywordSearchStaff: '',
  isUserListNullData: false,
  regions: [],
  units: [],
  departments: [],
  divisions: [],
  levels: [],
  survey360Objects: [],
  positions: [],
  restaurants: [],
  staffs: [],
  dataParamsDefault: {
    page: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
    regions: [],
    units: [],
    departments: [],
    divisions: [],
    levels: [],
    positions: [],
    restaurants: [],
  },
};

const surveyReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(surveyAction.setSurveyFilterUserList, (state, action) => {
      state.userListFilter = action.payload;
    })
    .addCase(surveyAction.setSurveyRegionsUserList, (state, action) => {
      state.regions = action.payload;
    })
    .addCase(surveyAction.setSurveyUnitsUserList, (state, action) => {
      state.units = action.payload;
    })
    .addCase(surveyAction.setSurveyDepartmentUserList, (state, action) => {
      state.departments = action.payload;
    })
    .addCase(surveyAction.setSurveyDivisionUserList, (state, action) => {
      state.divisions = action.payload;
    })
    .addCase(surveyAction.setSurveyRestaurantsUserList, (state, action) => {
      state.restaurants = action.payload;
    })
    .addCase(surveyAction.setSurveyPositionsUserList, (state, action) => {
      state.positions = action.payload;
    })
    .addCase(surveyAction.setSurveyLevelsUserList, (state, action) => {
      state.levels = action.payload;
    })
    .addCase(surveyAction.setSurvey360ObjectsUserList, (state, action) => {
      state.survey360Objects = action.payload;
    })
    .addCase(surveyAction.setSurveyStaffsUserList, (state, action) => {
      state.staffs = action.payload;
    })
    .addCase(surveyAction.clearFilterUserList, (state) => {
      state.staffs = initialState.staffs;
      state.regions = initialState.regions;
      state.units = initialState.units;
      state.departments = initialState.departments;
      state.divisions = initialState.divisions;
      state.levels = initialState.levels;
      state.positions = initialState.positions;
      state.restaurants = initialState.restaurants;
      state.survey360Objects = initialState.survey360Objects;
      state.userListFilter = initialState.userListFilter;
      state.isUserListNullData = initialState.isUserListNullData;
      state.dataParamsDefault = initialState.dataParamsDefault;
      state.keywordSearchStaff = '';
    })
    .addCase(surveyAction.setDataParamsDefault, (state, action) => {
      state.dataParamsDefault = action.payload;
    })
    .addCase(surveyAction.setUserListNullData, (state, action) => {
      state.isUserListNullData = action.payload;
    })
    .addCase(surveyAction.setKeywordSearchStaff, (state, action) => {
      state.keywordSearchStaff = action.payload;
    })
);
export default surveyReducer;
